module.exports = __webpack_public_path__ + "images/external_images/svg/mockups/laptop-and-phone-1.svg";